export default {

  // Controle de Login
  "setUser" (state, payload) {
    state.user = payload
  },
  "setAuthToken" (state, payload) {
    state.authToken = payload
  },  
  "setUploadToken" (state, payload) {
    state.uploadToken = payload
  },
  "setLoggingIn" (state, payload) {
    state.loggingIn = payload
  },

  // Mensagens/Notificações
  "setUpdateMessages" (state, payload) {
    state.updateMessages = payload
  },
  "setUpdateNotifications" (state, payload) {
    state.updateNotifications = payload
  },

  // Dashboard
  "setOpenQuotationsChartData" (state, payload) {
    state.openQuotationsChartData = payload
  },
  "setConsolidatedQuotationsChartData" (state, payload) {
    state.consolidatedQuotationsChartData = payload
  },
  "setQuotationsWaitingConfirmationChartData" (state, payload) {
    state.quotationsWaitingConfirmationChartData = payload
  },

  // Consulta de Produtos
  "setProducts" (state, payload) {
    state.products = payload
  },
  "setBitolas" (state, payload) {
    state.bitolas = payload
  },
  "setColors" (state, payload) {
    state.colors = payload
  },
  "setBalances" (state, payload) {
    state.balances = payload
  },
  "setBalancesFilter" (state, payload) {
    state.balancesFilter = payload
  },

  // Reservas
  "setReserves" (state, payload) {
    state.reserves = payload
  },
  "setReservesFilter" (state, payload) {
    state.reservesFilter = payload
  },
  "setReservesCustomers" (state, payload) {
    state.reservesCustomers = payload
  },
  "setReservesSellers" (state, payload) {
    state.reservesSellers = payload
  },
  "setReservesUsers" (state, payload) {
    state.reservesUsers = payload
  },

  // Consulta de Clientes
  "setCustomers" (state, payload) {
    state.customers = payload
  },
  "setCustomersFilters" (state, payload) {
    state.customersFilter = payload
  },
  "setSegments" (state, payload) {
    state.segments = payload
  },

  // Orçamentos
  "setQuotations" (state, payload) {
    state.quotations = payload
  },
  "setQuotationsFilter" (state, payload) {
    state.quotationsFilter = payload
  },
  "setQuotationsUsers" (state, payload) {
    state.quotationsUsers = payload
  },
  "setQuotationsSellers" (state, payload) {
    state.quotationsSellers = payload
  },
  "setQuotationsManagers" (state, payload) {
    state.quotationsManagers = payload
  },
  "setQuotationsCompetitors" (state, payload) {
    state.quotationsCompetitors = payload
  },
  "setQuotationsAttachmentsCategories" (state, payload) {
    state.quotationsAttachmentsCategories = payload
  },
}
